import DecryptageArticleModel from './DecryptageArticle.model';

export default class Decryptage {
  constructor({
    total,
    results,
    trust,
  } = {}) {
    this.total = total;
    this.results = results;
    this.trust = trust;
  }

  getTotal() {
    return this.total;
  }

  getDecodingArticles() {
    const articles = [];
    if (this.results) Object.entries(this.results).map((el) => articles.push(el[1]));
    return articles.map((val) => new DecryptageArticleModel(val));
  }

  getTrustTitle() {
    return this.trust?.title;
  }

  getTrustLinkUri() {
    return this.trust?.link?.uri ? this.trust?.link?.uri.replace(/internal:/, '') : '';
  }

  getTrustLinkTitle() {
    return this.trust?.link?.title;
  }

  getTrustLinkOptions() {
    return this.trust?.link?.options ?? [];
  }

  getTrustText() {
    return this.trust?.text;
  }

  getTrustImage() {
    return this.trust?.image;
  }
}
